import { AfterViewInit, Component, ElementRef, inject, Input, input, output, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiComponentsModule } from '@mwe/ui/components';
import { Observable } from 'rxjs';

@Component({
  selector: 'lib-ikp-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  standalone: true,
  imports: [CommonModule, UiComponentsModule],
})
export class PaginationComponent implements AfterViewInit {
  readonly currentPage = input<number>();
  readonly allPagesNumber = input<number>();
  readonly hasFixedHeader = input(false);
  readonly canChangePage = input(true);
  readonly dataUpdate$ = input(new Observable<unknown>());
  readonly dataTest = input<string>();
  readonly changePage = output<number>();

  protected renderer = inject(Renderer2);

  private readonly CSS_UNIT = 'px';
  private scrollTarget: Element;

  @Input() set paginatedElement(paginatedElement: HTMLElement | ElementRef) {
    if (paginatedElement instanceof HTMLElement) {
      this.scrollTarget = paginatedElement;
    } else {
      this.scrollTarget = paginatedElement.nativeElement;
    }
  }

  ngAfterViewInit(): void {
    if (this.hasFixedHeader()) {
      this.renderer.setStyle(this.scrollTarget, 'scroll-margin-top', `${this.getFixedHeaderOffset() + this.CSS_UNIT}`);
    }
    this.dataUpdate$().subscribe(() => {
      this.scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  onNextPage(): void {
    if (this.canChangePage()) {
      this.changePage.emit(this.currentPage() + 1);
    }
  }

  onPreviousPage(): void {
    if (this.canChangePage()) {
      this.changePage.emit(this.currentPage() - 1);
    }
  }

  getFixedHeaderOffset(): number {
    const headerComponent: HTMLElement = document.querySelector('lib-ikp-header');
    const nativeHeader: HTMLElement = headerComponent.querySelector('header');

    const height: number = Number.parseInt(getComputedStyle(nativeHeader).height.replace(this.CSS_UNIT, ''));
    const marginBottom: number = Number.parseInt(getComputedStyle(nativeHeader).marginBottom.replace(this.CSS_UNIT, ''));

    return height + marginBottom;
  }
}
